import * as React from "react"
import { usePosition } from "../hooks/usePosition"
import Ping from "ping.js"
import { useSocket } from "./socket-context"
import SearchUI from "../components/Search/SearchUI"

export const isBrowser = () => typeof window !== "undefined"

const StoryDataContext = React.createContext()

export const StoryDataProvider = ({ uid, isPrivate, children, ...props }) => {
  const { socket, userInfo } = useSocket()
  const { latitude, longitude } = usePosition()
  const [loadingStoryData, setLoadingStoryData] = React.useState(true)
  const [positionObtained, setPositionObtained] = React.useState(false)
  const [skipPosition, setSkipPosition] = React.useState(false)
  const [gatheredUID, setGatheredUID] = React.useState(uid ? uid : null)
  const [storyData, setStoryData] = React.useState({})

  React.useEffect(() => {
    if (socket && positionObtained && gatheredUID) {
      const payload = {
        uid: gatheredUID,
        lat: latitude || userInfo.lat,
        lon: longitude || userInfo.lon,
        isISPLocation: longitude ? false : true,
      }
      isPrivate
        ? socket.emit("private-story", payload)
        : socket.emit("story", payload)
      socket.on("story-update", data => {
        setLoadingStoryData(false)
        setStoryData(oldData => ({
          ...oldData,
          ...data,
          userInfo,
          clientInfo: { lat: latitude, lon: longitude },
        }))
      })
    }
  }, [socket, positionObtained, uid, gatheredUID])

  React.useEffect(() => {
    if (storyData.url && !storyData.networkLatency) {
      ;(async () => {
        const p = new Ping()
        let time = -1
        try {
          const req = await p.ping(`https://${storyData.url}`)
          time = req
        } catch (e) {
          time = e
        }
        setStoryData(oldData => ({ ...oldData, networkLatency: time }))
      })()
    }
  }, [storyData])

  React.useEffect(() => {
    if (skipPosition || (latitude && longitude)) {
      setPositionObtained(true)
    }
  }, [latitude, longitude, skipPosition])

  return (
    <StoryDataContext.Provider
      value={{
        storyData,
        loadingStoryData,
        positionObtained,
        uid,
        submitted: gatheredUID,
        skipPositionObtain: () => setSkipPosition(true),
        setGatheredUID,
        isPrivate,
      }}
      {...props}
    >
      <div className="relative">
        {!gatheredUID && (
          <div className="absolute top-0 left-0 z-40 w-full h-full flex items-center justify-center ">
            <SearchUI />
          </div>
        )}
        {children}
      </div>
    </StoryDataContext.Provider>
  )
}

export const useStoryData = () => React.useContext(StoryDataContext)

export default StoryDataContext
